module.exports = __webpack_public_path__ + "img/noads.bf484809.svg";